import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'page-edit-alerts',
  templateUrl: 'alerts.component.html'
})
export class AlertsEditComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/alerts/alerts.component.ts